import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import CoinGeckoCMCLHero from "./CoinGeckoCMCLHero";
import CoinMarketCap from "./CoinMarketCap";
import CompleteListing from "./CompleteListing";

function CoinGeckoCMCListing() {
  return (
    <div>
      <Header />
      <CoinGeckoCMCLHero />
      <CoinMarketCap />
      <CompleteListing />
      <Footer />
    </div>
  );
}

export default CoinGeckoCMCListing;
